import { FunctionComponent, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Header } from '../../components/common/Header/Header';
import { Sidebar } from '../../components/common/Sidebar/Sidebar';
import { SidebarLink } from '../../components/common/Sidebar/SidebarLink';
import { useCountries } from '../../hooks/useCountries';
import { useHeaders } from '../../hooks/useHeaders';
import { useAuth } from '../../services/auth/AuthProvider';

/**
 * Party header and sidebar.
 */
export const PartyHeader: FunctionComponent = () => {
    const { currentCountry } = useCountries();
    const { signIn, signOut, user } = useAuth();
    const { headerLinks } = useHeaders();

    const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);

    const sidebarUser = useMemo(() => {
        return (
            user && {
                userName: user.username,
                firstName: user.firstname,
                lastName: user.lastname,
            }
        );
    }, [user]);

    const closeSidebar = () => setSidebarOpen(false);

    const handleMenuClick = () => setSidebarOpen(true);

    const handleLoginClick = () => {
        closeSidebar();
        signIn();
    };

    const handleLogoutClick = () => {
        closeSidebar();
        void signOut();
    };

    const onCookiesClick = () => {
        closeSidebar();
        window.Cookiebot?.renew();
    };

    return (
        <>
            <Header onMenuClick={handleMenuClick} />

            {headerLinks && (
                <Sidebar
                    open={sidebarOpen}
                    user={sidebarUser}
                    profileEditLink={currentCountry.urlProfile}
                    onProfileEditClick={closeSidebar}
                    onLoginClick={handleLoginClick}
                    onLogoutClick={handleLogoutClick}
                    onClose={closeSidebar}
                    primaryLinks={headerLinks.mainNavigation.map((hl) => (
                        <SidebarLink component="a" type="primary" href={hl.url} target={hl.target} onClick={closeSidebar}>
                            {hl.title}
                        </SidebarLink>
                    ))}
                    secondaryLinks={[
                        ...headerLinks.secondaryNavigation.map((sl) => (
                            <SidebarLink component="a" type="secondary" href={sl.url} target={sl.target} onClick={closeSidebar}>
                                {sl.title}
                            </SidebarLink>
                        )),
                        <SidebarLink component="button" type="secondary" onClick={onCookiesClick}>
                            <FormattedMessage id="sidebar.link-secondary-cookies" defaultMessage="Om cookies" />
                        </SidebarLink>,
                    ]}
                />
            )}
        </>
    );
};
